import { useState } from "react";

import { UserIdentity } from "~/api/Api";

import { IdentitySelectionModalProps } from "./types";

export const useIdentitySelectionController = ({
  identities,
  onIdentitySelected,
}: {
  identities: UserIdentity[];
  onIdentitySelected: (identity: UserIdentity) => Promise<void>;
}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const onRequestIdentitySelection = () => {
    if (identities.length === 1) {
      onIdentitySelected(identities[0]);
    } else {
      setModalOpen(true);
    }
  };

  const onClose = () => setModalOpen(false);

  const onIdentityChosen = (identity: UserIdentity) => {
    onIdentitySelected(identity);
    setModalOpen(false);
  };

  const modalProps: IdentitySelectionModalProps = {
    isOpen: isModalOpen,
    onClose,
    identities,
    onIdentityChosen,
  };

  return {
    onRequestIdentitySelection,
    modalProps,
  };
};
